import { __decorate } from "tslib";
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    version;
    dateTimeFormatted = '';
    timeID;
    get currTime() {
        return this.dateTimeFormatted.split('  ')[1];
    }
    get currDay() {
        return this.dateTimeFormatted.split(' ')[0];
    }
    refeshDateTime() {
        this.dateTimeFormatted = moment().format('YYYY-MM-DD  HH:mm:ss');
        this.timeID = setTimeout(() => {
            this.refeshDateTime();
        }, 1000);
    }
    startUpClock() {
        this.refeshDateTime();
    }
    turnOffClock() {
        this.timeID && clearTimeout(this.timeID);
    }
    mounted() {
        this.startUpClock();
    }
    beforeDestroy() {
        this.turnOffClock();
    }
};
__decorate([
    Prop()
], default_1.prototype, "version", void 0);
default_1 = __decorate([
    Component({
        name: 'Clock'
    })
], default_1);
export default default_1;
